export const enCommonTranslations = {
	common: {
		login: 'Log In',
		logout: 'Log Out',
		getStarted: 'Get Started',
		unpublish: 'Unpublish',
		previous: 'Previous',
		next: 'Next',
		slide: 'Slide',
		lightMode: 'Light mode',
		darkMode: 'Dark mode',
		loading: 'Loading...',
		error: 'An error occurred',
		retry: 'Retry',
		save: 'Save',
		cancel: 'Cancel',
		delete: 'Delete',
		edit: 'Edit',
		view: 'View',
		create: 'Create',
		update: 'Update',
		close: 'Close',
		and: 'and',
		filter: 'Filter',
		export: 'Export',
		clearFilters: 'Clear Filters',
		yes: 'Yes',
		no: 'No',
		english: 'English',
		arabic: 'العربية',
		language: 'Language',
		currency: 'Currency',

		hideFilters: 'Hide Filters',
		showFilters: 'Show Filters',
		backToOrders: 'Back to Orders',
		all: 'All',
		search: 'Search',
		showing: 'Showing',
		total: 'Total',
		of: 'of',
		uploadFile: 'Upload File',
		dragAndDrop: 'Drag and Drop',
		expand: 'Expand',
		collapse: 'Collapse',
		ingredientName: 'Ingredient Name',
		enterIngredientName: 'Enter ingredient name',
		arabicName: 'Arabic Name (Optional)',
		enterArabicName: 'أدخل اسم المكون بالعربية',
		groupName: 'Group Name',
		enterGroupName: 'Enter group name',
		selectIngredients: 'Select Ingredients',
		noIngredientsFound: 'No ingredients found',
		noGroupsFound: 'No groups found',
		noIngredientsAvailable: 'No ingredients available. Create some ingredients first.',
		tryAdjustingSearch: 'Try adjusting your search terms',
		startByAddingFirst: 'Start by adding your first ingredient',
		startByCreatingFirst: 'Start by creating your first ingredient group',
		searchGroups: 'Search groups...',
		ingredients: 'ingredients',
		deleteIngredientConfirm: 'Are you sure you want to delete this ingredient? This action cannot be undone.',
		deleteGroupConfirm: 'Are you sure you want to delete this group? This will also remove all ingredient relationships in this group.',

		saving: "Saving...",
		dashboard: "Dashboard",

		success: 'Success',
		notification: 'Notification',
		dismiss: 'Dismiss',
		actions: 'Acions',
		reset: 'Reset',
		trigger: 'Trigger',
		suggested: 'Suggested',

		pagination: {
			showing: 'Showing {{start}} to {{end}} of {{total}} results',
			previous: 'Previous',
			next: 'Next',
			page: 'Page',
			of: 'of',
			goToPage: 'Go to page {{page}}',
			itemsPerPage: 'Items per page'
		},
		ingredientManagement: {
			title: 'Ingredient Management',
			selectedIngredients: 'Selected Ingredients',
			selectedGroups: 'Selected Groups',
			ingredientsAndGroups: 'Ingredients & Groups',
			searchIngredients: 'Search ingredients and groups...',
			noItemsSelected: 'No items selected yet. Click the + button to add ingredients or groups.',
			ingredients: 'ingredients',
			noResults: 'No {{type}} found matching "{{term}}"',
			noAvailable: 'No available {{type}} to add'
		},
		variants: {
			dynamicOptions: 'Dynamic Options',
			variantsSelected: 'variants selected',
			noVariantsConfigured: 'No variants configured',
			configureVariantsInSettings: 'Configure variants in branch settings to enable dynamic options for this item.',
			noOptionsConfigured: 'No options configured for this variant',
			noComboConfigured: 'No combo configuration available',
			default: 'Default',
			price: 'Price',
			note: 'Note',
			status: 'Status',
			active: 'Active',
			inactive: 'Inactive',
			addToItem: 'Add to Item',
			removeFromItem: 'Remove from Item',
			required: 'Required',
			optional: 'Optional',
			selections: 'selections',
			comboPrice: 'Combo Price',
			comboItems: 'Combo Items',
			multiselection: 'Multi-selection',
			selectionRange: 'Selection Range',
			optionsCount: 'Options Count',
			comboData: 'Combo Data',
			formName: 'Form Name',
			actionType: 'Action Type',
			minSelection: 'Min Selection',
			maxSelection: 'Max Selection',
			selectionOptions: 'Selection Options',
			addOption: 'Add Option',
			addComboItem: 'Add Item',
			option: 'Option',
			optionName: 'Option Name',
			comboConfiguration: 'Combo Configuration',
			addItem: 'Add Item',
			item: 'Item',
			itemName: 'Item Name',
			quantity: 'Quantity',
			basicInfo: 'Basic Information',
			basicInfoDesc: 'Set the variant name and type',
			configuration: 'Configuration',
			configurationDesc: 'Configure selection rules and requirements',
			selectionRules: 'Selection Rules',
			selectionLimits: 'Selection Limits',
			formNamePlaceholder: 'e.g., Size Options, Drink Choice',
			optionNamePlaceholder: 'e.g., Large, Medium',
			notePlaceholder: 'Optional note',
			itemNamePlaceholder: 'e.g., Burger, Fries',
			selectionOptionsDesc: 'Add the available options for customers to choose from',
			comboConfigDesc: 'Configure combo items and pricing',
			noOptionsAdded: 'No options added yet. Click "Add Option" to get started.',
			noItemsAdded: 'No items added yet. Click "Add Item" to get started.',
			editDescription: 'Modify your variant configuration',
			createDescription: 'Create a new variant configuration for your menu items',
			comboOrOptionsRequired: 'Either combo items or upgrade options are required',
			invalidExistingSelection: 'One or more combo items require a menu item to be selected or switch to a custom name',
			selectMenuItem: 'Select Menu Item',
			searchMenuItems: 'Search menu items...',
			requiredNeedsDefault: 'Required forms must have at least one default option',
			formNameRequired: 'Form name is required',
			actionTypeRequired: 'Action type is required',
			minSelectionInvalid: 'Minimum selection must be 0 or greater',
			maxSelectionInvalid: 'Maximum selection must be greater than or equal to minimum',
			optionsRequired: 'At least one option is required',
			formNameSection: 'Form Name',
			formNameAr: 'Arabic Form Name',
			formNameArPlaceholder: 'Enter Arabic form name',
			priceDefaultPlaceholder: '0.00',
			optionNameAr: 'Arabic Name',
			optionNameArPlaceholder: 'Enter Arabic option name',
			newOption: 'New Option',
			settings: 'Settings',
			requiredDescription: 'Customer must select this variant',
			multiselectionDescription: 'Allow multiple options to be selected',
			description: 'Description (optional)',
			descriptionPlaceholder: 'Add a description (optional)',
			noteAr: 'Arabic Note',
			noteArPlaceholder: 'Enter Arabic note',
			descriptionAr: 'Arabic Description',
			descriptionArPlaceholder: 'Enter Arabic description',
			activeVariantsSummary: 'Active Variants on this Item',
			management: {
				title: 'Variant Management',
				description: 'Manage variant configurations for this branch',
				addVariant: 'Add Variant',
				editVariant: 'Edit Variant',
				noVariants: 'No Variants Configured',
				noVariantsDescription: 'Start by creating your first variant configuration',
				createFirst: 'Create First Variant',
				deleteTitle: 'Delete Variant',
				deleteDescription: 'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
				searchPlaceholder: 'Search variants...',
				totalVariants: 'total variants',
				showing: 'showing',
				allTypes: 'All Types',
				noResults: 'No Results Found',
				noResultsDescription: 'Try adjusting your search criteria or filters',
				options: 'Options',
				addComboItem: 'Add Combo Item',
				optionalPrice: 'Optional Price',
			}
		}
	},
	currencies: {
		title: 'Currencies',
		subtitle: 'Manage branch currencies and exchange rates',
		addCurrency: 'Add Currency',
		editCurrency: 'Edit Currency',
		currencyName: 'Currency Name',
		currencyCode: 'ISO Code',
		currencySymbol: 'Currency Symbol',
		exchangeRate: 'Exchange Rate',
		baseCurrency: 'Base Currency',
		setAsBase: 'Set as base currency',
		noCurrencies: 'No currencies added yet',
		addSuccess: 'Currency added successfully',
		updateSuccess: 'Currency updated successfully',
		deleteSuccess: 'Currency deleted successfully',
		addError: 'Failed to add currency',
		updateError: 'Failed to update currency',
		deleteError: 'Failed to delete currency',
		deleteCurrency: 'Delete Currency',
		deleteConfirmation: 'Are you sure you want to delete this currency? This action cannot be undone.',
		precision: 'Decimal Precision',
	},
	notifications: {
		loginSuccess: 'Successfully logged in',
		registerSuccess: 'Account created successfully',
		organizationCreated: 'Organization created successfully',
		organizationUpdated: 'Organization updated successfully',
		branchCreated: 'Branch created successfully',
		branchUpdated: 'Branch updated successfully',
		branchDeleted: 'Branch deleted successfully',
		categoryCreated: 'Category created successfully',
		categoryUpdated: 'Category updated successfully',
		categoryDeleted: 'Category deleted successfully',
		menuItemCreated: 'Menu item created successfully',
		menuItemUpdated: 'Menu item updated successfully',
		menuItemDeleted: 'Menu item deleted successfully',
		unexpectedError: 'An unexpected error occurred'
	}
}